import styled from "styled-components";
import { device,breakpoints } from "../../../utils/responsive_utilities";
import { white,black,blackLight } from '../../../components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  padding: 7rem 0 14rem 0;
  @media (min-width: ${breakpoints.md}px) {
    padding: 8rem 0 3.2rem 0;
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 10.8rem 0 8rem 0;
  }
  @media ${device.Desktop} {
    padding: 12.8rem 0 17rem 0;
  }
`;

export const CartonImg = styled.div`
  width: 13.1rem;
  height: 17rem;
  > img {
    width: 100%;
    height: 100%;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: 16.2rem;
    height: 21rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 13.7rem;
    height: 17.8rem;
    margin-top: 2rem;
  }
`;

export const HaveQuesFlexContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  @media (min-width: ${breakpoints.md}px) {
    width: 68%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 92%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media ${device.Desktop} {
    width: 85%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

export const HaveQuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: max-content;
  @media (min-width: ${breakpoints.lg}px) {
    flex: 1;
    flex-direction: column-reverse;
    margin-top: 1.2rem;
  }
`;

export const HaveQuesTitle = styled.h2`
  margin: 2.5rem auto 0;
  text-align: left;
  color: ${black};
  ${styledFont('Graphie', 2.8, 3.2, 7)}
  @media (min-width: ${breakpoints.md}px) {
    ${styledFont('Graphie', 3.2, 3.8, 7)}
  }
  @media (min-width: ${breakpoints.lg}px) {
    margin-top: 0;
    ${styledFont('Graphie', 4, 4.8, 7)}
  }
`;

export const HaveQuesBody = styled.div`
  margin: 0.8rem auto 0;
  color: ${blackLight};
  ${styledFont('Graphie', 1.6, 2.4, 4)}
`;

export const AccordionContainer = styled.div`
  margin-top: 2.2rem;
  @media (min-width: ${breakpoints.lg}px) {
    flex: 1;
    margin: 0 0 0 2.8rem;
  }
`;

